import React from "react";
import { Card, CardContent } from "@material-ui/core";
import { sortableElement, sortableContainer } from "react-sortable-hoc";
import MenuIcon from "@material-ui/icons/Menu";
import colors from "../../styles/colors";

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

const SortableItem = sortableElement(({ value }) => {
  return (
    <Card
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        justifyItems: "center",
        border: "solid 1px",
        borderColor: colors.primary,
        borderRadius: 5,
        marginBottom: 5,
        boxShadow: "1px 3px 1px #9E9E9E",
        backgroundColor: "white",
        zIndex: 999999,
        padding: 7,
      }}
    >
      <CardContent style={{ padding: 0 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: 16,
            alignItems: "center",
            color: value.archived ? "#A8A8A8" : "black",
            fontFamily: "Poppins-Regular",
          }}
        >
          <div>
            {value.programName}
            <div>
              {value.startDate}
              {value.endDate && " - "}
              {value.endDate}
            </div>
          </div>
          <MenuIcon />
        </div>
      </CardContent>
    </Card>
  );
});

export default (props) => {
  return (
    <SortableContainer onSortEnd={props.onSortEnd}>
      {props.programs.map((item, index) => {
        return (
          <SortableItem
            key={`item-${item.programId}`}
            index={index}
            value={item}
          />
        );
      })}
    </SortableContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/SortableProgram.js